import { render } from "./ListingSettingsColumnItem.vue?vue&type=template&id=8352b4e2&scoped=true"
import script from "./ListingSettingsColumnItem.vue?vue&type=script&lang=js"
export * from "./ListingSettingsColumnItem.vue?vue&type=script&lang=js"

import "./ListingSettingsColumnItem.vue?vue&type=style&index=0&id=8352b4e2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8352b4e2"]])

export default __exports__